import React from 'react';
import { 
  Shield, 
  Zap, 
  Clock, 
  FileCheck, 
  Users,
  Globe,
  Lock,
  BarChart3
} from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: Zap,
      title: 'Fast Verification',
      description: 'Clients complete verification in 3-5 minutes with our mobile-first experience. Real-time guidance and auto-capture make it effortless.',
      color: 'blue'
    },
    {
      icon: Shield,
      title: 'Audit-Grade Evidence',
      description: 'Every action is logged, timestamped, and immutable. Export complete audit packs with evidence hashes and decision trails.',
      color: 'green'
    },
    {
      icon: FileCheck,
      title: 'No Repeated KYC',
      description: 'Once verified, clients can securely share their verification with other companies. Build a network of trust.',
      color: 'purple'
    },
    {
      icon: Clock,
      title: 'Ongoing Monitoring',
      description: 'Get alerts when client circumstances change. Stay compliant without manual checks or spreadsheets.',
      color: 'amber'
    },
    {
      icon: Globe,
      title: 'Multi-Jurisdiction',
      description: 'Support for UK, EU, and US compliance requirements. Region packs adapt workflows automatically.',
      color: 'blue'
    },
    {
      icon: Lock,
      title: 'Bank-Grade Security',
      description: 'End-to-end encryption, secure evidence storage, and strict access controls. Your data is never compromised.',
      color: 'red'
    },
    {
      icon: Users,
      title: 'Team Collaboration',
      description: 'Role-based access for admins, reviewers, and staff. Full audit trail of all internal actions.',
      color: 'indigo'
    },
    {
      icon: BarChart3,
      title: 'Compliance Reporting',
      description: 'Generate regulatory reports, track completion rates, and demonstrate your compliance posture.',
      color: 'teal'
    }
  ];

  return (
    <div className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Features</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Everything you need to streamline client due diligence while maintaining 
            the highest compliance standards.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            const colorClasses = {
              blue: 'bg-blue-100 text-blue-600',
              green: 'bg-green-100 text-green-600',
              purple: 'bg-purple-100 text-purple-600',
              amber: 'bg-amber-100 text-amber-600',
              red: 'bg-red-100 text-red-600',
              indigo: 'bg-indigo-100 text-indigo-600',
              teal: 'bg-teal-100 text-teal-600'
            };
            return (
              <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 ${colorClasses[feature.color]}`}>
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600 text-sm">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Features;
